import React, { useContext } from "react";
import PropTypes from "prop-types";
import { DocumentContext } from "~context/DocumentContext";

import darkGreenWave from "~assets/images/dark-green-wave.png";
import darkGreenWaveXS from "~assets/images/dark-green-wave-xs.png";
import lightGreenWave from "~assets/images/light-green-wave.png";
import lightGreenWaveXS from "~assets/images/light-green-wave-xs.png";
import orangeWave from "~assets/images/orange-wave.png";
import orangeWaveXS from "~assets/images/orange-wave-xs.png";
import whiteWave from "~assets/images/white-wave.png";
import whiteWaveXS from "~assets/images/white-wave-xs.png";

//

const WavySection = ({ children, className, color }) => {
  const { device } = useContext(DocumentContext);

  let wave;
  let waveXS;

  switch (color) {
    case `green`:
    case `dark-green`:
      wave = darkGreenWave;
      waveXS = darkGreenWaveXS;
      break;

    case `light-green`:
      wave = lightGreenWave;
      waveXS = lightGreenWaveXS;
      break;

    case `orange`:
      wave = orangeWave;
      waveXS = orangeWaveXS;
      break;

    case `white`:
    default:
      wave = whiteWave;
      waveXS = whiteWaveXS;
      break;
  }

  return (
    <section
      className={`${className} w-full relative block z-10 -mt-12 md:-mt-16 lg:-mt-24 pt-12 pb-4`}
    >
      <div className="w-full absolute top-0 right-0 bottom-0 left-0">
        {(device && device === `mobile` && (
          <img
            className="w-full h-full relative block"
            src={waveXS}
            alt={`${color} wave XS`}
          />
        )) || (
          <img
            className="w-full h-full relative block"
            src={wave}
            alt={`${color} wave`}
          />
        )}
      </div>

      <div className="grid z-10 pt-12 sm:pt-16 md:pt-24 pb-24 sm:pb-20 md:pb-32">
        {children}
      </div>
    </section>
  );
};

WavySection.defaultProps = {
  className: ``,
  color: `cream`
};

WavySection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string
};

export default WavySection;
